<div class="d-flex align-items-center adicionar_itens_menu_superior" [ngClass]="{ 'adicionar_itens_menu_mobile_fechado': !menuMobileExpandido, 'justify-content-between': configuracao != null && ((!configuracao.prazo_pagamento_antes_itenspedido && configuracao.utiliza_fator_financeiro) || configuracao.usa_conta_corrente_flex || (clienteSelecionado != null && (clienteSelecionado.limite_credito_disponivel != null || clienteSelecionado.credito_financeiro != null))), 'justify-content-end': configuracao != null && (configuracao.prazo_pagamento_antes_itenspedido && !configuracao.usa_conta_corrente_flex && (clienteSelecionado != null && clienteSelecionado.limite_credito_disponivel == null && clienteSelecionado.credito_financeiro == null)) }" #toolbarRoot>
  <!-- Prazo de Pagamento -->

  @if (configuracao != null && !configuracao.prazo_pagamento_antes_itenspedido && configuracao.utiliza_fator_financeiro) {
    <div class="form-row flex-grow-1 mr-4">
      <div class="form-group" [ngClass]="{ 'col-sm-6' : configuracao != null && configuracao.usar_desconto_prazo_medio == 'S', 'col-sm-9' : configuracao != null && configuracao.usar_desconto_prazo_medio != 'S' }">
        <label><b>Prazo de Pagamento:</b></label>
        <app-prazo-pagamento-select
          [prazosIniciais]="prazosPagamentoIniciais"
          [prazosEspeciais]="prazosPagamentoEspeciais"
          [prazoSelecionado]="prazoPagamentoSelecionado"
          [desabilitado]="clienteSelecionado == null"
          [invalido]="prazoPagamentoInvalido"
          [ocultarTitulosIniciais]="configuracao != null && configuracao.flag_usa_prazo_vinculado_cliente"
          (prazoChange)="prazoAlterado.emit({ id_prazo_pagamento: $event.toString(), cabecalho: false })">
        </app-prazo-pagamento-select>
        @if (prazoPagamentoInvalido) {
          <div class="erro pt-1">Prazo de Pagamento inválido!</div>
        }
      </div>
      <div class="form-group col-sm-3">
        <label><b>Prazo Médio:</b></label>
        <input class="form-control form-control-sm" type="text" name="prazo_medio" [value]="prazoMedio == null || prazoMedio.prazomedio == 0 ? '' : prazoMedio.prazomedio" disabled />
      </div>
      @if (configuracao != null && configuracao.usar_desconto_prazo_medio == 'S') {
        <div class="form-group col-sm-3">
          <label><b>Desconto Máximo: %</b></label>
          <input class="form-control form-control-sm" type="text" name="desconto" [value]="prazoMedioDesconto == null ? '' : prazoMedioDesconto.percentual_desconto" disabled />
        </div>
      }
    </div>
  }

  <!-- Conta Corrente -->

  @if (configuracao != null && configuracao.usa_conta_corrente_flex) {
    <div class="adicionar_itens_valor">
      <h6 class="text-secondary"><b>Saldo Disponível: R$</b></h6>
      <h6><b>{{ contaCorrenteSaldoDisponivel | currency: 'BRL' }}</b></h6>
    </div>
    <div class="adicionar_itens_valor text-right">
      <h6 class="text-secondary"><b>Saldo Gerado: R$</b></h6>
      <h6><b>{{ saldoGeradoValorParcial | currency: 'BRL' }}</b></h6>
    </div>
  }

  <!-- Limite -->

  @if (clienteSelecionado != null && clienteSelecionado.limite_credito_disponivel != null) {
    <div class="adicionar_itens_valor text-right">
      <h6 class="text-secondary"><b>Limite (Cliente): R$</b></h6>
      <h6><b>{{ clienteSelecionado.limite_credito_disponivel | currency: 'BRL' }}</b></h6>
    </div>
  }
  @if (clienteSelecionado != null && clienteSelecionado.credito_financeiro != null) {
    <div class="adicionar_itens_valor text-right">
      <h6 class="text-secondary"><b>Credito Disponivel: R$</b></h6>
      <h6><b>{{ clienteSelecionado.credito_financeiro | currency: 'BRL' }}</b></h6>
    </div>
  }

  <!-- Pontuação Total -->

  @if (exibirPontuacao) {
    <div class="adicionar_itens_valor text-right">
      <h6 class="text-secondary"><b>Pontuação (Total):</b></h6>
      <h6><b>{{ pontuacaoTotal | number: '1.2-2' }}</b></h6>
    </div>
  }

  <!-- Ações -->

  <div class="ia-atalhos-itens" *ngIf="clienteSelecionado != null">
    <button type="button" class="btn ia-atalho" title="IA NAPIS" aria-label="IA NAPIS" (click)="iaPainelAlternado.emit()">
      <i class="fa fa-magic" aria-hidden="true"></i>
    </button>
    <button type="button" class="btn ia-atalho ia-atalho-produtos" title="Sugerir Produtos" aria-label="Sugerir Produtos" (click)="produtosSugeridos.emit()" [disabled]="iaCarregando">
      <i class="fa fa-lightbulb-o" aria-hidden="true"></i>
    </button>
  </div>

</div>
